/**
 * Composable for branding-related utilities
 * Provides methods to customize text with installation-specific branding
 */
import { useMapGetter } from 'dashboard/composables/store.js';

export function useBranding() {
  // Try to get globalConfig from the store (dashboard context) or window (widget context)
  const globalConfig = (() => {
    try {
      return useMapGetter('globalConfig/get');
    } catch {
      // Fallback to window.globalConfig for widget context
      return { value: window.globalConfig || {} };
    }
  })();
  
  /**
   * Replaces "Chatwoot" in text with the installation name from global config
   * @param {string} text - The text to process
   * @returns {string} - Text with "Chatwoot" replaced by installation name
   */
  const replaceInstallationName = text => {
    if (!text) return text;

    const installationName = globalConfig.value?.installationName;
    if (!installationName || installationName === 'Chatwoot') return text;

    return text.replace(/Chatwoot/g, installationName);
  };

  return {
    replaceInstallationName,
  };
}
